'use strict';

var React = require('react');

var SvgExploreImagesMajor = function SvgExploreImagesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.385 11a3.385 3.385 0 1 0 1.65 6.34l1.39 1.39a.923.923 0 1 0 1.305-1.306l-1.39-1.39a3.385 3.385 0 0 0-2.956-5.035Zm-1.539 3.385a1.538 1.538 0 1 1 3.077 0 1.538 1.538 0 0 1-3.077 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.487c0-.821.666-1.487 1.487-1.487h14.865c.821 0 1.487.666 1.487 1.487v8.228a5.919 5.919 0 0 0-2.973-.796c-.838 0-1.635.174-2.358.486l-.714-1.24a.496.496 0 0 0-.833-.02l-3.033 4.739-1.615-1.835a.494.494 0 0 0-.714.01l-3.52 4.015a.49.49 0 0 0 .396.783h6.527c.119.711.365 1.38.713 1.982h-8.228a1.487 1.487 0 0 1-1.487-1.487v-14.865Zm8.424 3.964c0-1.09-.892-1.982-1.982-1.982-1.09 0-1.982.892-1.982 1.982 0 1.09.892 1.982 1.982 1.982 1.09 0 1.982-.892 1.982-1.982Z"
  }));
};

exports.SvgExploreImagesMajor = SvgExploreImagesMajor;
